import styled from "@emotion/styled";
import Button from "../../UI/Button";
import theme from "../../UI/theme";

export const ProfilePicture = styled.img`
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0px 2px 4px 2px #ccc;
    margin-bottom: 1rem;
`;

export const ProfilePictureWrapper = styled.div`
    text-align: center;
`;

export const MainWrapper = styled.div`
    display: flex;
    padding: 2rem 0 2rem 2rem;
    @media screen and (max-width: 991px) {
        padding: 2rem 0 0 0;
    }
`;

export const InnerWrapper = styled.div`
    width: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    gap: 1rem;
`;

export const ProfileName = styled.div`
    margin-top: -1rem;
    font-weight: ${theme.typography.fontWeight.bold};
    color: ${theme.colors.darkGray};
    font-size: 18px;
`;

export const EditProfileText = styled.div`
    color: ${theme.colors.primary};
    cursor: pointer;
    font-size: 0.8rem;
`;

export const ChangeConsultationButton = styled(Button)`
    background-color: ${theme.colors.primary};
    color: white;
    width: 100%;
    font-size: 0.8rem;
    height: 44px;
    transition: 0.2s ease all;
    &:hover {
        transform: scale(1.1);
    }
`;
